"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
const Tab_1 = __importDefault(require("@material-ui/core/Tab"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        minWidth: 100,
        overflow: 'visible',
        '& .button': {
            position: 'absolute',
            fontSize: 10,
            maxHeight: 12,
            opacity: 0.8,
            transition: 'max-height 0.3s',
            '&:hover': {
                maxHeight: 32,
            },
        },
        '& .save': {
            top: 2,
        },
        '& .reset': {
            bottom: 4,
        },
    },
});
exports.Tab = react_1.default.memo((props) => {
    const { onSave, onReset, label, classes } = props, otherProps = __rest(props, ["onSave", "onReset", "label", "classes"]);
    const myCss = (0, web_css_1.default)(makeMyClasses, [], classes);
    const handleClickSave = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        onSave === null || onSave === void 0 ? void 0 : onSave();
    }, [onSave]);
    const handleClickReset = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        onReset === null || onReset === void 0 ? void 0 : onReset();
    }, [onReset]);
    const labelComponent = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        label,
        !!onSave && (react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.primary, classes: { root: 'save button' }, small: true, onClick: handleClickSave, label: lib_i18n_1.default.t('save') })),
        !!onReset && (react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.GreyBlue, classes: { root: 'reset button' }, small: true, onClick: handleClickReset, label: lib_i18n_1.default.t('reset') })))), [label, onSave, handleClickSave, onReset, handleClickReset]);
    return (react_1.default.createElement(Tab_1.default, Object.assign({ classes: { root: myCss.root }, component: "div" }, otherProps, { label: labelComponent })));
});
exports.default = exports.Tab;
